export default __webpack_public_path__ + "static/media/past-due-assignment.6429bac5.png";